<div class="loginPage">
  <h2 class="form__title">Welcome back!</h2>
  <p class="form__subtitle">Unlock your passion for sports log in to stay connected</p>
  <div class="">
    <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
      <div class="form-group">
        <label class="form__label">Email address / Phone number*</label>
        <div class="{{ keyUpValue() ? 'phoneNo' : '' }}">
          <span *ngIf="keyUpValue()">+1</span>
          <!-- <input
            type="text"
            formControlName="email"
            class="form__input form-control"
            [attr.maxlength]="keyUpValue() ? 10 : null"
            placeholder="Enter email/ phone number"
          /> -->
          <input type="text" formControlName="email" class="form__input form-control" placeholder="Enter email/ phone number" />
        </div>
        <!-- <input type="text" *ngIf="keyUpValue()==false" formControlName="email" class="form__input form-control" name="email"
          placeholder="Enter email/ phone number"> -->
        <div *ngIf="loginForm.controls['email'].hasError('required') && showError" class="validation-error">*Please enter email/phone number.</div>
        <div *ngIf="loginForm.controls['email'].hasError('pattern') && showError" class="validation-error">*Invalid email, phone number.</div>
      </div>
      <div class="form-group mb-24">
        <label class="form__label">Password</label>
        <div class="password__box">
          <input
            [type]="isPasswordVisible ? 'text' : 'password'"
            class="form__input form-control"
            placeholder="Enter your password"
            autocomplete
            formControlName="password"
          />
          <a href="javascript:void(0)" (click)="isPasswordVisible = !isPasswordVisible" class="toggle__image">
            <!-- <img
              src="{{ isPasswordVisible ? '../../../assets/images/ic_eye_opened.svg' : '../../../assets/images/ic_eye_closed.svg' }}"
              alt="ic_eye_closed"
            /> -->
            <div *ngIf="isPasswordVisible" [innerHTML]="ICONS.eyeOpenIcon | safeHtml"></div>
            <div *ngIf="!isPasswordVisible" [innerHTML]="ICONS.eyeCloseIcon | safeHtml"></div>
          </a>
        </div>
        <div *ngIf="loginForm.controls['password'].hasError('required') && showError" class="validation-error">*Please enter the password.</div>
        <!-- <div class="validation-error"
        *ngIf="(loginForm.controls['password'].hasError('minlength') || loginForm.controls['password'].hasError('maxlength')) && showError">
        Password must be at least 8 characters long and contain at least one uppercase letter,one lowercase letter, one number,
        and one special character. </div> -->
      </div>
      <div class="login__actions">
        <label class="login__remember-me">
          <input type="checkbox" class="form__checkbox" formControlName="rememberMe" name="rememberMe" /> Remember Me
        </label>
      </div>
      <button type="submit" class="common--button" [class.btn-loading]="isLoading" [disabled]="loginForm.invalid || disableLogin">Login</button>
    </form>
    <div class="login__link">
      <a routerLink="/auth/forgot" class="links" href="javascript:void(0)"
        >Forgot password <span class="authLinkIcon" [innerHTML]="ICONS.icArrow | safeHtml"></span
      ></a>
      <a class="links" href="javascript:void(0)" routerLink="/auth/signup">
        CREATE AN ACCOUNT <span class="authLinkIcon" [innerHTML]="ICONS.icArrow | safeHtml"></span>
      </a>
    </div>
  </div>
</div>
